/**
 * Lokaler Zustand des Wizards (Schritt, Channel-Auswahl, Feld-Auswahl je
 * Channel, globales Recherche-Flag). Feld-Auswahl liegt in `useFieldSelections`
 * (eigener Hook wegen der 50-Zeilen-Grenze).
 */

import { useState } from 'react'

import { useFieldSelections } from './useFieldSelections'
import type { RecipeDefault } from './useFieldSelections'
import type { BulkAttributeCode } from '@/lib/api/channel-content-bulk'

export type { FieldSelection, FieldSelections, RecipeDefault } from './useFieldSelections'

export function useWizardState(initialChannelIds?: string[]) {
  const [step, setStep] = useState(0)
  const [selectedChannelIds, setSelectedChannelIds] = useState<string[]>(initialChannelIds ?? [])
  // Default AN: Das Fakten-Briefing wird 1x je Produkt erzeugt und über ALLE
  // Kanäle wiederverwendet. Ohne es wiederholen die Texte messbar nur die
  // Stammdaten; mit ihm stehen belegbare Produktfakten drin.
  const [researchEnabled, setResearchEnabled] = useState(true)
  const { fieldSelections, setFieldSelection, initChannelDefaults } = useFieldSelections()

  const toggleChannel = (channelId: string, recipeDefaults?: Partial<Record<BulkAttributeCode, RecipeDefault>>) => {
    const isAdding = !selectedChannelIds.includes(channelId)
    setSelectedChannelIds((prev) =>
      prev.includes(channelId) ? prev.filter((id) => id !== channelId) : [...prev, channelId],
    )
    if (isAdding) initChannelDefaults(channelId, recipeDefaults)
  }

  return {
    step, setStep,
    selectedChannelIds, toggleChannel,
    fieldSelections, setFieldSelection,
    researchEnabled, setResearchEnabled,
  }
}
